import { getGroupedCarriersByParent } from 'helpers/carriers/carriers';
import { parseZohoJsonOutput } from 'helpers/zoho/response-parsers';

export function parseUntappedAgentsOutput(rawOutput) {
  const { ok, message, data } = parseZohoJsonOutput(rawOutput);

  return {
    ok,
    message,
    agents: data?.agents && typeof data.agents === 'object' ? data.agents : {}
  };
}

export function listUntappedAgents(agentsMap) {
  return Object.entries(agentsMap ?? {})
    .map(([compositeKey, agent]) => {
      const availableCarriers = Array.isArray(agent?.availableCarriers)
        ? agent.availableCarriers
        : [];
      if (availableCarriers.length === 0) return null;

      const id = String(agent?.id ?? compositeKey);
      const name = String(agent?.name ?? '').trim() || id;
      const email = String(agent?.email ?? '')
        .trim()
        .toLowerCase();

      return {
        agentId: id,
        agentName: name,
        email,
        npn: agent?.npn != null ? String(agent.npn).trim() : '',
        availableCarriers,
        agencyId: agent?.agencyId ?? '',
        agencyName: agent?.agencyName ?? ''
      };
    })
    .filter(Boolean)
    .sort(
      (a, b) =>
        (a.agencyName || '').localeCompare(b.agencyName || '') ||
        a.agentName.localeCompare(b.agentName)
    );
}

export function normalizeAvailableCarrierForDisplay(carrier) {
  if (!carrier || typeof carrier !== 'object') return null;

  return {
    id: carrier.id != null ? String(carrier.id) : '',
    name: String(carrier.name ?? '').trim(),
    carrierIcon: carrier.carrierIcon ?? null,
    carrierIconColor: carrier.carrierIconColor ?? null,
    carrierIconDescription: carrier.carrierIconDescription ?? null,
    appointmentParentGroup: String(carrier.appointmentParentGroup ?? '').trim(),
    appointmentGroup: carrier.appointmentGroup ?? '',
    considersStates: carrier.considersStates === true,
    untappedStates: Array.isArray(carrier.states) ? carrier.states : []
  };
}

/**
 * Groups available carriers by appointmentParentGroup / appointmentGroup
 * (same structure as Commissions All Carriers).
 */
export function groupAvailableCarriersByParent(availableCarriers) {
  if (!Array.isArray(availableCarriers) || availableCarriers.length === 0) {
    return [];
  }

  const normalized = availableCarriers
    .map(normalizeAvailableCarrierForDisplay)
    .filter(c => c?.name);

  if (normalized.length === 0) return [];

  return getGroupedCarriersByParent(normalized, undefined, null);
}
